import { render, staticRenderFns } from "./mob-layout.vue?vue&type=template&id=3255e0c7&"
import script from "./mob-layout.vue?vue&type=script&lang=js&"
export * from "./mob-layout.vue?vue&type=script&lang=js&"
import style0 from "./mob-layout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports